import { getQueryParams } from '@/utils/urlQuery';

export const hasQueryFlag = (flag: string) => {
  if (typeof window === 'undefined') return false;
  try {
    return getQueryParams(window.location.search).get(flag) === '1';
  } catch {
    return String(window.location.search || '').includes(`${flag}=1`);
  }
};

export const isTkTuneEnabled = () => hasQueryFlag('tkTune');
export const isTkDebugEnabled = () => hasQueryFlag('tkDebug');
export const isTkDebugFiller = () => hasQueryFlag('tkDebugFiller');
export const isTkDisableFiller = () => hasQueryFlag('tkDisableFiller');
